import React, { useState } from 'react';
import axiosInstance from '../../axiosInstance';

const AddProject = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');
  const [technologies, setTechnologies] = useState([]);
  const [image, setImage] = useState(null);


  const handleTechnologiesChange = (e) => {
    const techs = e.target.value.split(',').map((tech) => tech.trim());
    setTechnologies(techs);
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('link', link);
    technologies.forEach((tech, index) => {
        formData.append(`technologies[${index}]`, tech);
    });
    if (image) {
        formData.append('media', image);
    }
    console.log('Image file:', formData.get('media'));
    
    try {
      const response = await axiosInstance.post('/projects', formData,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Project created:', response.data);
    } catch (error) {
      console.error('Error creating project:', error);
    }
  };

  return (
    <div className='max-w-7xl mx-auto px-4'>
      <h1 className="text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]">Projects</h1>
      <form onSubmit={handleSubmit} className='w-[60%] max-sm:w-full' encType="multipart/form-data">
        <div>
          <label className='dark:text-white text-[#111318]'>Title:</label>
          <input type="text" name="title" value={title} onChange={(e) => setTitle(e.target.value)} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'/>
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Image:</label>
          <input type="file" onChange={(e) => {const file = e.target.files[0];setImage(file);console.log('Image selected:', file);}}  className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'/>
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Description:</label>
          <textarea type="text" name="description" value={description} onChange={(e) => setDescription(e.target.value)} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'></textarea>
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Link:</label>
          <input type="text" name="link" value={link} onChange={(e) => setLink(e.target.value)}  className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2  text-gray-900 dark:text-[rgb(211,219,236)]'/>
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Technologies:</label>
          <input type="text" name="technologies" value={technologies.join(', ')} onChange={handleTechnologiesChange} className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'/>
        </div>
        <button type="submit" className='bg-blue-200 dark:bg-yellow-600 px-6 py-3 text-gray-900 dark:text-[rgb(211,219,236)] rounded-md hover:dark:bg-yellow-700 hover:bg-blue-400'>Add Project</button>
      </form>
      {/*<ul>
        {projects.map(project => (
          <li key={project._id} className='dark:text-white text-[#111318]' >{project.title}</li>
        ))}
      </ul>*/}
    </div>
  );
};

export default AddProject;
